export default "__VITE_ASSET__BQgCvYJV__"